module.exports = __webpack_public_path__ + "img/infinity4.98409f58.jpg";